import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { format,parse,differenceInSeconds } from 'date-fns';
import { asyncScheduler } from 'rxjs';
import { takeWhile } from "rxjs/operators";
import addDays from 'date-fns/addDays';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import {
    FvmsCommonService
    ,FvmsMapApiProvidor
    ,FvmsApiDtgCarService
    ,FvmsDtgCarDriveHisService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
    ,dtgCarTypeList
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.test.t02.component.html'
    ,styleUrls: []
    ,providers: []
})
export class DtgTestT02Component implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    searchValue:string;
    @Input() selectedCar:any;
    dateTimeInfo:any;
    mapService:any;
    listTripInfo:any[];
    listHisInfo:any[];
    selectedTripInfo:any;
    sumCnt:number = 0;
    sumDist:number = 0;
    sumDuration:number = 0;
    sumSpeed:number = 0;
    avgSpeed:number = 0;

    @Input()
    set selectedCarInput(selectedCar){
        if(selectedCar){
            this.selectedCar = selectedCar;
            this.mapService.initMapContainer("map-container-02");
            this.mapService.addControlViewMode();
            this.mapService.addControlZoom();
            this.mapService.addControlCopyright();
            this.mapService.initLatLngBounds();
            this.mapService.initGeocoder();

            this.reloadListDriveHisTripInfo();
            this.mapService.relayout();
        }
    }

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsMapApiProvidor:FvmsMapApiProvidor
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsDtgCarDriveHisService:FvmsDtgCarDriveHisService
        ,public activeModal: NgbActiveModal
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.dateTimeInfo = this.fvmsCommonService.getDateInfo();
        this.mapService = this.fvmsMapApiProvidor.getMapApiService();
        this.fvmsDtgCarDriveHisService.subjectListHis
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(listHis => {
                // clear map
                this.listHisInfo = listHis;
            });
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        
    }

    reloadListDriveHisTripInfo(){
        // let self = this;
        // let tmpSearchInfo:any = {
        //     dtgUnitId:this.selectedCar.dtgUnitId
        //     ,searchDateFrom:this.fvmsCommonService.getDateFromIso()
        //     ,searchDateTo:this.fvmsCommonService.getDateToIso()
        // };
        // this.fvmsCommonService.setIsLoading(true);
        // this.fvmsApiDtgCarService.getListTripInfo(tmpSearchInfo)
        //     .pipe(takeWhile(() => this.isContinue))
        //     .subscribe(apiResTrip => {
        //         if(apiResTrip.resultStatus === "ok"){
        //             if(apiResTrip.resultValue){
        //                 this.listTripInfo = apiResTrip.resultValue;

        //                 if(this.fvmsDtgCarDriveHisService.checkIndexDbSupport()){
        //                     this.fvmsDtgCarDriveHisService.initDb().then(() => {
        //                         this.listTripInfo.map(async (itemTrip,idxTrip) => {
        //                             // console.log("listTripInfo",idxTrip,itemTrip.dtgUnitId,itemTrip.fvmsTripCnt,itemTrip.dtgRegDtFrom,itemTrip.dtgRegDtTo);
        //                             let tmpSearchInfo:any = {
        //                                 dtgUnitId:itemTrip.dtgUnitId
        //                                 ,fvmsTripCnt:itemTrip.fvmsTripCnt
        //                                 ,searchDateFrom:itemTrip.dtgRegDtFrom
        //                                 ,searchDateTo:itemTrip.dtgRegDtTo
        //                                 ,eventTimeLimitSec:5
        //                             };
        //                             let pagingInfo = {
        //                                 "curPage":1
        //                                 ,"pageSize":60*60*24
        //                             };
        //                             let apiResHis:any = await this.fvmsApiDtgCarService.getListDriveHistory(tmpSearchInfo,pagingInfo).pipe(takeWhile(() => this.isContinue)).toPromise();
        //                             console.log("listTripInfo",apiResHis);
        //                             if(apiResHis.resultStatus === "ok"){
        //                                 await this.fvmsDtgCarDriveHisService.addListHisData(apiResHis.resultValue);
        //                             }
        //                         });
        //                         this.fvmsCommonService.setIsLoading(false);
        //                     });
        //                 }
        //             }
        //         }
        //     }
        //     ,errTrip => {
        //         console.error("reloadListDriveHisTripInfo","getListTripInfo",errTrip);
        //         this.fvmsCommonService.setIsLoading(false);
        //     }
        //     ,() => {});
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    // 트립 선택
    changeTripInfoSelect(event:any,idx:number,fvmsTripCnt:number){

    }

    // 초당 데이터 row mouse over
    showMarkerDriveHis(idxHis:any,driveHis:any){

    }

    // 초당 데이터 row mouse out
    hideMarkerDriveHis(){

    }
}